import { createAction } from '@reduxjs/toolkit';

export const implementationSectionActions = {
  notification: createAction<{ customMessage: string }>('ImplementationSection/Notification'),
};
